module.exports = __webpack_public_path__ + "fonts/TelefonicaWeb-Regular.5fd39de0.woff";